export enum InstitutionAttributeChannel {
  CREATE = 'institutionAttribute::create',
  EDIT = 'institutionAttribute::patch',
  DELETE = 'institutionAttribute::delete',
}
